import { render, staticRenderFns } from "./ProductsRelagosPage.vue?vue&type=template&id=3f583ed4&scoped=true&"
import script from "./ProductsRelagosPage.vue?vue&type=script&lang=js&"
export * from "./ProductsRelagosPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductsRelagosPage.vue?vue&type=style&index=0&id=3f583ed4&prod&lang=scss&"
import style1 from "./ProductsRelagosPage.vue?vue&type=style&index=1&id=3f583ed4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f583ed4",
  null
  
)

export default component.exports